import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { HttpClient } from '@angular/common/http';
import { AuthService, ResponseObject } from './auth.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InstagramAccount, InstagramAccountsApiResponce, SocialPostData, SoicalPost } from '../models/socialpost.model';

@Injectable({
  providedIn: 'root'
})
export class InstagramService extends ServiceBase{
  private api = '/Instagram'

  constructor(private http: HttpClient,
      authService: AuthService) { 
        super(authService);
  }

  public onloginWithInstagram(): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/login-with-instagram';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponseObject>(url, httpOptions);
  }

  public onInstagramAccountsCallBack(code: string,state: string): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/callback-to-store-token';
    const url: string = environment.BASE_API_PATH + this.api + method;
    console.log(code,state)
    return this.http.post<ResponseObject>(url,{ code,state }, httpOptions);
  }

  public onPostPublish(savePost: SoicalPost): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/publish-your-post';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,savePost, httpOptions);
  }

  public onGetConnectedInstagramAccounts() : Observable<InstagramAccount>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetch-connected-accounts';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<InstagramAccount>(url, httpOptions);
  }

  public onGetAllInstagramAccounts(IsFetchInstagramAccountsInsights: boolean) : Observable<InstagramAccountsApiResponce[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = `/fetch-all-accounts/${IsFetchInstagramAccountsInsights}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<InstagramAccountsApiResponce[]>(url, httpOptions);
  }

  public onDeactiveAllAccount(): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/Disconnect-all-ccount';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.delete<ResponseObject>(url,httpOptions);
  }
  public deleteAllInstagramMetaData(username: string, password: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/DeleteMetaRequest';
    const url: string = environment.BASE_API_PATH + this.api + method;
    const body = { username, password };
    return this.http.delete<ResponseObject>(url, { ...httpOptions, body });
}

  public onDeactiveAccount(instaUserId : string): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = `/Disconnect-account/${instaUserId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

}
